<div
  (click)="onPlay($event)"
  (keydown)="onPlay($event)"
  [attr.data-gtm]="'video-preview-on-play'"
  class="video-preview"
  tabindex="0"
>
  <div class="video-preview__image">
    <img
      *ngIf="imageUrl"
      [src]="imageUrl"
      alt="video preview image"
      class="video-preview__image__preview"
    />
  </div>
  <div class="video-preview__play-button">
    <ui-svg-icon
      iconClassName="icon-video-preview--play"
      svgId="play"
    ></ui-svg-icon>
  </div>
</div>
